import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    marketplaceDeal: null,
    marketplaceDeals: null,
    isNew: false,
    lastState: null,
    lastScope: null
};

const marketplaceDealsReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.MARKETPLACEDEAL_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.MARKETPLACEDEAL_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.MARKETPLACEDEAL_FAIL: {
            return updateState(state, { lastState: constants.STATE_FAIL });
        }
        default: {
            return state;
        }
    }
};

export default marketplaceDealsReducer;
